import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import kittyGallery from '../assets/kitty-photography.png';
import basicKitty from '../assets/basic-kitty.png';
import config from '../config';

const Gallery = () => {
  const [photos, setPhotos] = useState([]);
  const [lightboxPhoto, setLightboxPhoto] = useState(null);
  const [imagesLoaded, setImagesLoaded] = useState(new Set());
  const [activeNav, setActiveNav] = useState(1);

  useEffect(() => {
    fetchPhotos();
  }, []);

  const fetchPhotos = async () => {
    try {
      console.log('Fetching photos from frontend...');
      const response = await fetch(`${config.API_URL}/api/photos`);
      console.log('Response status:', response.status);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('Received photos:', data.length);
      setPhotos(data);
    } catch (error) {
      console.error('Failed to fetch photos:', error);
    }
  };

  const handleImageLoad = (photoId) => {
    setImagesLoaded(prev => new Set([...prev, photoId]));
  };

  const openLightbox = (photo) => {
    setLightboxPhoto(photo);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setLightboxPhoto(null);
    document.body.style.overflow = 'unset';
  };


  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f8fafc 0%, #e0e7ef 25%, #fdf2f8 50%, #f1f5f9 75%, #fdf4ff 100%)',
      fontFamily: "'Playfair Display', 'Georgia', serif",
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Floating background elements */}
      {Array.from({ length: 12 }, (_, i) => (
        <div
          key={i}
          style={{
            position: 'absolute',
            width: Math.random() * 6 + 4 + 'px',
            height: Math.random() * 6 + 4 + 'px',
            borderRadius: '50%',
            background: `linear-gradient(45deg, 
              rgba(219, 39, 119, ${0.1 + Math.random() * 0.3}), 
              rgba(168, 85, 247, ${0.1 + Math.random() * 0.3}))`,
            left: Math.random() * 100 + '%',
            top: Math.random() * 100 + '%',
            animation: `photo-float ${3 + Math.random() * 4}s ease-in-out infinite`,
            animationDelay: Math.random() * 2 + 's',
          }}
        />
      ))}

      {/* Navigation Bar */}
      <nav style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(20px)',
        zIndex: 1000,
        padding: '1rem 2rem',
        borderBottom: '1px solid rgba(219, 39, 119, 0.1)',
        transition: 'all 0.3s ease'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}>
            <img 
              src={basicKitty} 
              alt="Kitty Logo" 
              style={{
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                objectFit: 'cover',
                border: '2px solid #db2777',
                boxShadow: '0 2px 8px rgba(219, 39, 119, 0.2)'
              }} 
            />
            <div style={{
              fontSize: '1.5rem',
              fontWeight: '700',
              background: 'linear-gradient(45deg, #db2777, #a855f7, #ec4899)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              letterSpacing: '0.5px'
            }}>MC</div>
          </div>
          <div style={{ display: 'flex', gap: '2rem' }}>
            {[
              { name: 'Home', path: '/' },
              { name: 'Gallery', path: '/gallery' },
              { name: 'Career', path: '/career' },
              { name: 'Admin', path: '/admin' }
            ].map((item, index) => (
              <Link 
                key={item.name} 
                to={item.path}
                style={{
                  cursor: 'pointer',
                  fontWeight: '500',
                  color: activeNav === index ? '#db2777' : '#64748b',
                  transition: 'all 0.3s ease',
                  position: 'relative',
                  padding: '0.5rem 0',
                  textDecoration: 'none'
                }}
                onMouseEnter={() => setActiveNav(index)}
                onMouseLeave={() => setActiveNav(1)}
              >
                {item.name}
                {activeNav === index && (
                  <div style={{
                    position: 'absolute',
                    bottom: '0',
                    left: '0',
                    right: '0',
                    height: '2px',
                    background: 'linear-gradient(90deg, #db2777, #ec4899)',
                    borderRadius: '1px'
                  }} />
                )}
              </Link>
            ))}
          </div>
        </div>
      </nav>

      {/* Header Section */}
      <section style={{
        padding: '8rem 2rem 3rem 2rem',
        textAlign: 'center',
        position: 'relative',
        zIndex: 10
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '2rem',
          marginBottom: '2rem',
          flexWrap: 'wrap'
        }}>
          <div style={{
            position: 'relative',
            padding: '1rem',
            background: 'rgba(255, 255, 255, 0.9)',
            borderRadius: '1.5rem',
            boxShadow: '0 10px 30px rgba(219, 39, 119, 0.2)',
            border: '2px solid rgba(219, 39, 119, 0.1)',
            animation: 'gentle-bounce 3s ease-in-out infinite'
          }}>
            <img 
              src={kittyGallery} 
              alt="Gallery Kitty" 
              style={{
                width: '80px',
                height: '80px',
                objectFit: 'contain',
                display: 'block'
              }} 
            />
          </div>
          <div>
            <h1 style={{
              fontSize: 'clamp(2.5rem, 6vw, 4rem)',
              fontWeight: '700',
              margin: '0',
              background: 'linear-gradient(45deg, #db2777, #a855f7, #ec4899)',
              backgroundSize: '200% 200%',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              animation: 'gradient-shift 4s ease-in-out infinite'
            }}>Gallery</h1>
            <p style={{
              fontSize: '1.3rem',
              color: '#64748b',
              fontStyle: 'italic',
              margin: '0.5rem 0 0 0'
            }}>Marissa's Gallery</p>
          </div>
        </div>
      </section>

      {/* Masonry Photo Gallery */}
      <section style={{
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '0 2rem 4rem 2rem',
        position: 'relative',
        zIndex: 10
      }}>
        {photos.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: '4rem 2rem',
            background: 'rgba(255, 255, 255, 0.8)',
            borderRadius: '2rem',
            backdropFilter: 'blur(20px)',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.1)'
          }}>
            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>📸</div>
            <h3 style={{
              fontSize: '1.5rem',
              color: '#64748b',
              fontWeight: '600',
              margin: '0'
            }}>No photos yet</h3>
            <p style={{
              color: '#94a3b8',
              fontSize: '1.1rem',
              margin: '0.5rem 0 0 0'
            }}>Photos will appear here once uploaded</p>
          </div>
        ) : (
          <div style={{
            columnCount: 'auto',
            columnWidth: '350px',
            columnGap: '20px',
            columnFill: 'balance'
          }}>
            {photos.map((photo, index) => {
              const isLoaded = imagesLoaded.has(photo._id);
              return (
                <div
                  key={photo._id}
                  style={{
                    breakInside: 'avoid',
                    marginBottom: '20px',
                    background: 'rgba(255, 255, 255, 0.9)',
                    borderRadius: '1rem',
                    overflow: 'hidden',
                    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.1)',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer',
                    opacity: isLoaded ? 1 : 0,
                    transform: isLoaded ? 'translateY(0)' : 'translateY(20px)',
                    border: '1px solid rgba(219, 39, 119, 0.1)'
                  }}
                  onClick={() => openLightbox(photo)}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.boxShadow = '0 15px 40px rgba(219, 39, 119, 0.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.1)';
                  }}
                >
                  <div style={{ position: 'relative', overflow: 'hidden' }}>
                    <img 
                      src={photo.s3Url} 
                      alt={photo.originalName}
                      onLoad={() => handleImageLoad(photo._id)}
                      style={{ 
                        width: '100%', 
                        height: 'auto',
                        display: 'block',
                        transition: 'transform 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'scale(1.05)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'scale(1)';
                      }}
                    />
                    <div style={{
                      position: 'absolute',
                      inset: 0,
                      background: 'linear-gradient(45deg, rgba(219, 39, 119, 0.1), rgba(168, 85, 247, 0.1))',
                      opacity: 0,
                      transition: 'opacity 0.3s ease'
                    }} 
                    onMouseEnter={(e) => {
                      e.target.style.opacity = 1;
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.opacity = 0;
                    }}
                    />
                  </div>
                  {photo.description && (
                    <div style={{ padding: '1rem' }}>
                      <p style={{ 
                        margin: '0', 
                        fontSize: '0.9rem', 
                        color: '#64748b',
                        lineHeight: 1.5
                      }}>
                        {photo.description}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </section>

      {/* Lightbox */}
      {lightboxPhoto && (
        <div 
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0, 0, 0, 0.9)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2000,
            padding: '2rem',
            animation: 'lightbox-appear 0.3s ease-out'
          }}
          onClick={closeLightbox}
        >
          <div style={{
            position: 'relative',
            maxWidth: '90vw',
            maxHeight: '90vh',
            background: 'white',
            borderRadius: '1rem',
            overflow: 'hidden',
            boxShadow: '0 25px 80px rgba(0, 0, 0, 0.5)',
            animation: 'lightbox-scale 0.3s ease-out'
          }}
          onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={closeLightbox}
              style={{
                position: 'absolute',
                top: '1rem',
                right: '1rem',
                background: 'rgba(0, 0, 0, 0.7)',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '20px',
                fontWeight: 'bold',
                zIndex: 10,
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(219, 39, 119, 0.8)';
                e.target.style.transform = 'scale(1.1)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'rgba(0, 0, 0, 0.7)';
                e.target.style.transform = 'scale(1)';
              }}
            >
              ×
            </button>
            <img 
              src={lightboxPhoto.s3Url} 
              alt={lightboxPhoto.originalName}
              style={{ 
                width: '100%', 
                height: 'auto',
                maxHeight: '80vh',
                objectFit: 'contain',
                display: 'block'
              }}
            />
            {lightboxPhoto.description && (
              <div style={{ 
                padding: '1.5rem',
                background: 'white',
                borderTop: '1px solid #e5e7eb'
              }}>
                <p style={{ 
                  margin: '0', 
                  fontSize: '1.1rem', 
                  color: '#374151',
                  lineHeight: 1.6,
                  textAlign: 'center'
                }}>
                  {lightboxPhoto.description}
                </p>
              </div>
            )}
          </div>
        </div>
      )}

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;800&family=Inter:wght@300;400;500;600;700&display=swap');
        
        @keyframes photo-float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-15px) rotate(180deg); }
        }
        
        @keyframes gentle-bounce {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-8px); }
        }
        
        @keyframes gradient-shift {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
        
        @keyframes lightbox-appear {
          0% { opacity: 0; }
          100% { opacity: 1; }
        }
        
        @keyframes lightbox-scale {
          0% { transform: scale(0.8); opacity: 0; }
          100% { transform: scale(1); opacity: 1; }
        }
        
        * {
          box-sizing: border-box;
        }
      `}</style>
    </div>
  );
};

export default Gallery; 